import pictureMuayThai from '../images/ImageSplit/MuayThai.jpg'
import pictureMMA from '../images/ImageSplit/MMA.jpg'
import pictureKettlebell from '../images/ImageSplit/Kettlebell.jpg'
import picturePowerlifting from '../images/ImageSplit/Powerlifting.jpg'
import pictureBodybuilding from '../images/ImageSplit/Bodybuilding.jpg'

const imageSplitData = {
    muayThai: { text: "Muay Thai", img: pictureMuayThai, link: "/sparten" },
    // mma: { text: "MMA", img: pictureMMA },
    kettlebell: { text: "Kettlebells", img: pictureKettlebell, link: "/sparten" },
    powerlifting: { text: "Powerlifting", img: picturePowerlifting, link: "/sparten" },
    bodybuilding: { text: "Bodybuilding", img: pictureBodybuilding, link: "/sparten" },
};

export default imageSplitData;